class AccountInfoBoxesComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
      <!-- almost done - upgrade card -->
      <div id="almost-done-row" class="row d-none pt-3" style="max-width: 900px;">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <a href="#" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade" style="text-decoration: none;">
                <div class="row">
                  <div class="col-2 text-success d-flex align-items-center justify-content-center">
                    <h3><i class="fa fa-cloud fa-2x"></i></h3>
                  </div>
                  <div class="col text-success">
                    <h3>You're almost done!</h3>
                    <h5>Click here to save & print projects for $19/month</h5>
                    <div class="col-md-8">
                      <div class="progress">
                        <div class="progress-bar progress-bar-striped bg-default" role="progressbar" style="width: 50%"
                          aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">1. Create account</div>
                        <div class="progress-bar bg-default" role="progressbar" style="width: 50%" aria-valuenow="50"
                          aria-valuemin="0" aria-valuemax="100"><span class="text-light">2. Start subscription</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div id="payment-failed-row" class="row d-none pt-3" style="max-width: 900px;">
        <div class="col-12">
          <div class="card bg-warning">
            <div class="card-body">
              <a href="#">
                <div class="row text-dark">
                  <div class="col-2 d-flex align-items-center justify-content-center">
                    <h3><i class="fa fa-warning fa-2x"></i></h3>
                  </div>
                  <div class="col-10">
                    <h3>We're having trouble processing your last payment.</h3>
                    <h4>Click here to manage your payment information</h4>

                    <div id="payment-failed-row-error" class="alert alert-danger d-none">
                      There was a problem getting your subscription information. Please contact support.
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div id="resubscribe-row" class="row d-none pt-3" style="max-width: 900px;">
        <div class="col-12">
          <div class="card bg-warning">
            <div class="card-body">
              <a href="#" data-bs-toggle="modal" data-bs-target="#modal-finish-upgrade">
                <div class="row text-dark">
                  <div class="col-2 d-flex align-items-center justify-content-center">
                    <h3><i class="fa fa-warning fa-2x"></i></h3>
                  </div>
                  <div class="col-10 text-start">
                    <h3>Your subscription was canceled or it has expired.</h3>
                    <h4>Click here to renew it.</h4>

                    <div id="resubscribe-row-error" class="alert alert-danger d-none">
                      There was a problem getting your subscription information. Please contact support.
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      `
  }
}

customElements.define('account-info-boxes', AccountInfoBoxesComponent);